<template>
  <div
    class="router-container"
    data-test="default-layout"
  >
    <slot />
  </div>
</template>

<style lang="postcss">
/* Preventing web pages moving left or right */
body,
#app,
.router-container {
  @apply overflow-hidden;
  @apply fixed w-full;
  @apply h-[100dvh];
}
</style>
